import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
  withCredentials: true,
  timeout: 300000,  // 5 minutes timeout for bulk uploads and large requests
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor to handle 401 errors globally
axiosInstance.interceptors.response.use(
  (response) => {
    // If response is successful, return it
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized errors
    if (error.response && error.response.status === 401) {
      // Check if we're not already on the login page or verify-session endpoint
      const currentPath = window.location.pathname;
      const isLoginPage = currentPath === '/login';
      const isVerifySession = error.config?.url?.includes('/auth/verify-session');
      
      // Only clear auth and redirect if not already on login page and not a verify-session call
      if (!isLoginPage && !isVerifySession) {
        console.warn('Session expired. Redirecting to login...');
        
        // Clear localStorage
        localStorage.removeItem('user');
        localStorage.removeItem('selectedStore');
        
        // Redirect to login
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
